module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Laptop-macbook-f63e7f195250acdd9a77d9def4150a1a.svg";